import { VisitStatus } from 'store/visits/types';
import { useIntl } from 'react-intl';
import { hexToRgba } from 'utils/hex-to-rgba';
import { getStatusColor } from 'shared/consts';

interface VisitStatusBadgeProps {
  status: VisitStatus;
  className?: string;
}

export const VisitStatusBadge = ({ status, className }: VisitStatusBadgeProps): JSX.Element => {
  const { formatMessage } = useIntl();
  const statusColor = getStatusColor(status);

  return (
    <span
      className={`inline-flex items-center gap-1 px-2 py-1 rounded-xl text-xs font-medium leading-normal max-w-max ${
        className || ''
      }`}
      style={{ backgroundColor: hexToRgba(statusColor, 0.1), color: statusColor }}
    >
      <span className="w-1 h-1 rounded-full shrink-0" style={{ backgroundColor: statusColor }} aria-hidden="true" />
      {formatMessage({ id: `labels.status.type.${status}` })}
    </span>
  );
};
